module.exports = __webpack_public_path__ + "img/value-hero3.cc738c95.jpg";